import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function FundersPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const benefits = [
    {
      icon: 'ri-search-line',
      title: '優質項目篩選',
      description: '嚴格篩選企業需求方，確保投資標的具有良好的商業模式與發展潛力'
    },
    {
      icon: 'ri-file-list-3-line',
      title: '完整盡職調查',
      description: '提供詳盡的企業財務分析與產業研究報告，協助降低投資風險'
    },
    {
      icon: 'ri-shield-check-line',
      title: '風險評估機制',
      description: '建立完善的風險評估機制，協助資金方做出明智的投資決策'
    },
    {
      icon: 'ri-line-chart-line',
      title: '投資組合建議',
      description: '協助資金方建立多元化投資組合，優化資產配置'
    },
    {
      icon: 'ri-service-line',
      title: '專業法律支援',
      description: '提供完整的法律文件審查與合約擬定服務'
    },
    {
      icon: 'ri-calendar-check-line',
      title: '後續追蹤服務',
      description: '投資後持續追蹤企業營運狀況，提供必要的協助'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      
      <div className="pt-32 pb-24 bg-gradient-to-br from-black to-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h1 className="text-5xl font-bold text-white mb-6">資金方服務</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            為資金提供方尋找優質投資標的，提供完整的盡職調查與風險評估服務
          </p>
        </div>
      </div>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">為什麼選擇朋睿？</h2>
              <p className="text-gray-700 mb-6 leading-relaxed text-lg">
                朋睿具備<strong>企業評估經驗</strong>與產業人脈，深入了解各產業的發展趨勢與投資機會。透過專業的<strong>盡職調查</strong>與<strong>風險評估</strong>，為資金方篩選出具有潛力的投資標的。
              </p>
              <p className="text-gray-700 mb-8 leading-relaxed text-lg">
                我們的服務不僅止於媒合，更提供投資後的持續追蹤與管理建議。無論您是銀行、創投、私募基金或個人投資者，朋睿都能為您提供專業的投資媒合服務。
              </p>

              <div className="bg-gray-50 rounded-xl p-8 border border-gray-200">
                <h3 className="text-xl font-bold text-gray-900 mb-6">適合的資金方類型</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <i className="ri-checkbox-circle-fill text-black text-xl mr-3"></i>
                    <span className="text-gray-700">商業銀行</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-checkbox-circle-fill text-black text-xl mr-3"></i>
                    <span className="text-gray-700">創投基金</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-checkbox-circle-fill text-black text-xl mr-3"></i>
                    <span className="text-gray-700">私募基金</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-checkbox-circle-fill text-black text-xl mr-3"></i>
                    <span className="text-gray-700">家族辦公室</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-checkbox-circle-fill text-black text-xl mr-3"></i>
                    <span className="text-gray-700">企業投資部門</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-checkbox-circle-fill text-black text-xl mr-3"></i>
                    <span className="text-gray-700">高資產個人</span>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/e6c1edf3a32bf1487556100a58a9e400.jpg"
                alt="資金方服務"
                className="w-full h-[500px] object-cover rounded-2xl shadow-xl"
              />
            </div>
          </div>

          <div className="mb-20">
            <h2 className="text-4xl font-bold text-gray-900 mb-4 text-center">服務內容</h2>
            <div className="w-20 h-1 bg-black mx-auto mb-12"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-xl transition-shadow"
                >
                  <div className="w-16 h-16 bg-black/10 rounded-lg flex items-center justify-center mb-6">
                    <i className={`${benefit.icon} text-3xl text-black`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-black to-gray-800 rounded-2xl p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-6">準備好開始投資了嗎？</h2>
            <p className="text-xl mb-8 text-white/90">
              立即聯繫我們，讓朋睿為您找到最佳的投資機會
            </p>
            <a
              href="https://line.me/R/ti/p/@678gwbht"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-4 bg-white text-black rounded-full font-bold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-chat-3-line text-2xl mr-3"></i>
              LINE 諮詢
            </a>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* LINE 客服按鈕 */}
      <a
        href="https://line.me/R/ti/p/@678gwbht"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-28 right-6 z-40 w-14 h-14 bg-[#06C755] rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform duration-300 group"
        aria-label="LINE 即時諮詢"
      >
        <i className="ri-line-fill text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          LINE 即時諮詢
        </span>
      </a>
    </div>
  );
}
